import styled from 'styled-components';

export const Video = styled('video')``;

export const Source = styled('source')``;
